import clsx from 'clsx';
import { MEASURE_RANGE_VALUES } from '../state/child-details';

export type RangeLabel = { cm: string; in: string };

const getValueLabel = (value: number, unit: 'cm' | 'in') => {
  let range;

  if (value === 0) {
    range = MEASURE_RANGE_VALUES[5];
  } else if (value < 6) {
    range = MEASURE_RANGE_VALUES[4];
  } else if (value < 11) {
    range = MEASURE_RANGE_VALUES[3];
  } else if (value < 16) {
    range = MEASURE_RANGE_VALUES[2];
  } else if (value < 21) {
    range = MEASURE_RANGE_VALUES[1];
  } else {
    range = MEASURE_RANGE_VALUES[0];
  }

  return <span className="w-10">{unit === 'cm' ? range.cmLabel : range.inLabel}</span>;
};

export const MeasureMark = ({
  value,
  unit,
  showAmount,
  isHidden = false,
}: {
  value: number;
  unit: 'cm' | 'in';
  showAmount?: boolean;
  isActive?: boolean;
  isHidden?: boolean;
  coefficient?: number;
}) => {
  return (
    <div
      className={clsx('h-0 border-t-2 relative select-none', {
        'border-t-green-forest w-10': !showAmount,
        'border-t-gray-medium w-15': showAmount,
        'opacity-0': isHidden,
      })}
    >
      {showAmount && (
        <div className="absolute -top-3 -right-13 text-[1.1875rem] h-5 flex items-center text-gray-medium whitespace-nowrap select-none">
          {getValueLabel(value, unit)}
        </div>
      )}
    </div>
  );
};
